import useGetDefaultUnit from '/business/shared/hooks/useGetDefaultUnit';

export type DefaultDistanceUnit = 'km' | 'miles';
type DefaultVolumeUnit = 'L/100km' | 'mpg';

function isDefaultDistanceUnit(unit: string | null): unit is DefaultDistanceUnit {
  return unit === 'km' || unit === 'miles';
}

export default function useGetDefaultDistanceUnit() {
  const unitPreffered = useGetDefaultUnit('distance');
  let defaultDistanceUnit: DefaultDistanceUnit = 'km';
  if (isDefaultDistanceUnit(unitPreffered)) {
    defaultDistanceUnit = unitPreffered;
  }
  const distanceUnit = defaultDistanceUnit;
  const defaultVolumeUnit: DefaultVolumeUnit = defaultDistanceUnit === 'km' ? 'L/100km' : 'mpg';

  return {
    distanceUnit,
    defaultVolumeUnit,
  };
}
